import { goto } from "./user.goto";
export * from "./UserRoutes";

export const userRoute = {
  goto: goto,
};
